// @flow

import type { ChatBubbleMessage } from '@chatchamp/chatchamp-types'

import { isProductsMessage, isTypingMessage } from '../../../models/Message'

import type { RootState } from '../../rootState'

import type { MessagesState } from './state'

function findLastMessage (state: MessagesState, predicate: Function): ?ChatBubbleMessage<any> {
  for (let i = state.messages.length - 1; i >= 0; --i) {
    if (predicate(state.messages[i])) return state.messages[i]
  }
  return null
}

export const getters = {
  showProgressBar (state: MessagesState): boolean {
    return !!state.progressMessage
  },
  latestMessage (state: MessagesState): ?ChatBubbleMessage<any> {
    return findLastMessage(state, m => !isTypingMessage(m))
  },
  latestMessageFromUser (state: MessagesState, _: any, rootState: RootState): ?ChatBubbleMessage<any> {
    return findLastMessage(state, m => rootState.customerId === m.to)
  },
  latestMessageFromBot (state: MessagesState, _: any, rootState: RootState): ?ChatBubbleMessage<any> {
    return findLastMessage(state, m => rootState.customerId === m.from)
  },
  latestProductsMessage (state: MessagesState): ?ChatBubbleMessage<any> {
    return findLastMessage(state, isProductsMessage)
  },
  latestMessageFromCustomer (state: MessagesState, getters: any): ?ChatBubbleMessage<any> {
    return findLastMessage(state, m => (getters.isFromCustomer(m) && !isTypingMessage(m)))
  },
  moreProductsClicked (state: MessagesState): boolean {
    return state.moreProductsClicked
  }
}
